var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1070B6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_219_1_",
    className: "st0",
    d: "M9.2,12.9c0.2,0,0.4-0.2,0.4-0.4V11c0-0.2-0.2-0.4-0.4-0.4H7.8c-0.2,0-0.4,0.2-0.4,0.4v1.4 c0,0.2,0.2,0.4,0.4,0.4h1.4V12.9z M13,12.5V11c0-0.2-0.2-0.4-0.4-0.4h-1.4c-0.2,0-0.4,0.2-0.4,0.4v1.4c0,0.2,0.2,0.4,0.4,0.4h1.4 C12.8,12.9,13,12.7,13,12.5z M16.4,12.5V11c0-0.2-0.2-0.4-0.4-0.4h-1.4c-0.2,0-0.4,0.2-0.4,0.4v1.4c0,0.2,0.2,0.4,0.4,0.4H16 C16.2,12.9,16.4,12.7,16.4,12.5z M13,15.8v-1.4c0-0.2-0.2-0.4-0.4-0.4h-1.4c-0.2,0-0.4,0.2-0.4,0.4v1.4c0,0.2,0.2,0.4,0.4,0.4h1.4 C12.8,16.2,13,16.1,13,15.8z M9.6,15.8v-1.4c0-0.2-0.2-0.4-0.4-0.4l0,0H7.8c-0.2,0-0.4,0.2-0.4,0.4v1.4c0,0.2,0.2,0.4,0.4,0.4h1.4 C9.4,16.3,9.6,16.1,9.6,15.8L9.6,15.8z M16.4,15.8v-1.4c0-0.2-0.2-0.4-0.4-0.4h-1.4c-0.2,0-0.4,0.2-0.4,0.4v1.4 c0,0.2,0.2,0.4,0.4,0.4H16C16.2,16.2,16.4,16.1,16.4,15.8z M19.7,6.7C19.7,5.8,19,5,18.1,5h-1.7V3.2c0-0.2-0.2-0.4-0.4-0.4h-1.4 c-0.2,0-0.4,0.2-0.4,0.4V5H9.6V3.2c0-0.2-0.2-0.4-0.4-0.4l0,0H7.8C7.6,2.8,7.4,3,7.4,3.2V5H5.7C4.8,5,4,5.8,4,6.7l0,0v12.4 c0,0.9,0.8,1.7,1.7,1.7h12.4c0.9,0,1.7-0.8,1.7-1.7L19.7,6.7z M18.1,18.9c0,0.1-0.1,0.2-0.2,0.2h-12c-0.1,0-0.2-0.1-0.2-0.2V8.4 h12.4C18.1,8.4,18.1,18.9,18.1,18.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a2b6bd73412c2592e71e8f1de115c7a8.svg";
export { ForwardRef as ReactComponent };